/**
 * Formular — the LBA sheet, complete, as the inspector's fifth tab.
 *
 * Nothing about the form's content changes here: it is what the school wants,
 * what the PDF stamps, and the only place where every cell is editable including
 * the ones the calculator owns. What changed is that it is one view of the
 * flight rather than the front door, so it measures the PANE it is given (an
 * inspector is ~420 px wide, far narrower than any window) and folds its route
 * table into per-leg cards on its own.
 */
import type { Aircraft } from '../../api';
import { PlanForm } from '../../components/PlanForm';
import { useT } from '../../i18n';
import { PaneNarrowProvider, useNarrowPane } from '../../media';

export function FormPane({
  aircraft = [],
  aircraftId = null,
  onPickAircraft,
}: {
  aircraft?: Aircraft[];
  aircraftId?: string | null;
  onPickAircraft?: ((id: string | null) => void) | undefined;
}) {
  const t = useT();
  const pane = useNarrowPane();
  return (
    <div className="ae-formpane" ref={pane.ref}>
      <p className="ae-pane-note">{t('form.pane.note')}</p>
      <PaneNarrowProvider value={pane.narrow}>
        <PlanForm
          aircraft={aircraft}
          aircraftId={aircraftId}
          {...(onPickAircraft ? { onPickAircraft } : {})}
        />
      </PaneNarrowProvider>
    </div>
  );
}

export default FormPane;
